<template>
  <section class="device-push">
    <strong><i class="fa-regular fa-bell" aria-hidden="true"></i> Уведомления на этом устройстве</strong>
    <p>{{ subscribed ? 'Новые ответы будут приходить и при закрытом кабинете.' : 'Получайте системные уведомления о новых комментариях.' }}</p>
    <button v-if="available && supported && permission !== 'denied'" type="button" :disabled="busy || checking" @click="subscribed ? disable() : enable()">{{ busy ? 'Сохраняем…' : subscribed ? 'Отключить на этом устройстве' : 'Включить уведомления' }}</button>
    <p v-else class="device-push-hint">{{ checking ? 'Проверяем доступность…' : !supported ? 'Этот браузер пока не поддерживает уведомления кабинета.' : permission === 'denied' ? 'Уведомления заблокированы. Разрешите их в настройках сайта.' : 'Системные уведомления пока недоступны.' }}</p>
    <p v-if="error" class="device-push-error" role="alert">{{ error }}</p>
  </section>
</template>
<script>
import { get, post } from '@/api'
import { pushSupported, pushRegistration, registerPushWorker, pushOwner, decodePushKey } from '@/utils/push'
export default {
  data: () => ({ available: false, supported: false, permission: 'default', subscribed: false, busy: false, checking: true, error: '', publicKey: '' }),
  mounted() { this.initialize() },
  beforeUnmount() { this.disposed = true },
  methods: {
    async initialize() {
      this.supported = pushSupported(); this.permission = typeof Notification === 'undefined' ? 'default' : Notification.permission
      try {
        const config = await get('push-config')
        if (this.disposed) return
        this.available = config.enabled; this.publicKey = config.public_key
        if (!this.supported) return
        const registration = await pushRegistration()
        if (!registration) return
        await pushOwner(registration, 0)
        const subscription = await registration.pushManager.getSubscription()
        if (subscription && this.available && this.permission === 'granted') {
          await post('push-subscribe', { subscription: subscription.toJSON() }, this.$store.state.csrf)
          if (this.disposed) return
          await pushOwner(registration, this.$store.state.user.id); this.subscribed = true
        }
      } catch (_) { if (!this.disposed) this.error = 'Не удалось проверить настройки уведомлений.' }
      finally { this.checking = false }
    },
    async enable() {
      if (this.busy || this.checking || !this.available || !this.supported) return
      this.busy = true; this.error = ''
      let registration, subscription
      try {
        this.permission = await Notification.requestPermission()
        if (this.permission !== 'granted' || this.disposed) return
        registration = await registerPushWorker()
        subscription = await registration.pushManager.getSubscription() || await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: decodePushKey(this.publicKey) })
        await post('push-subscribe', { subscription: subscription.toJSON() }, this.$store.state.csrf)
        if (this.disposed) return
        await pushOwner(registration, this.$store.state.user.id); this.subscribed = true
      } catch (error) {
        if (registration) await pushOwner(registration, 0).catch(() => {})
        if (subscription) await subscription.unsubscribe().catch(() => {})
        if (!this.disposed) this.error = error.message || 'Не удалось включить уведомления.'
      } finally { this.busy = false }
    },
    async disable() {
      if (this.busy) return
      this.busy = true; this.error = ''
      try {
        const registration = await pushRegistration(), subscription = await registration?.pushManager.getSubscription()
        if (subscription) await post('push-unsubscribe', { endpoint: subscription.endpoint }, this.$store.state.csrf)
        await pushOwner(registration, 0); await subscription?.unsubscribe(); this.subscribed = false
      } catch (error) { this.error = error.message || 'Не удалось отключить уведомления.' }
      finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.device-push { padding: 15px 18px; border-top: 1px solid #e5ebf3; background: #f7faff; }
.device-push > strong { color: #345376; font-size: 13px; }
.device-push > strong i { margin-right: 6px; }
.device-push p { margin: 7px 0; color: #6f8198; font-size: 12px; line-height: 1.5; }
.device-push button { margin-top: 5px; padding: 8px 12px; border: 1px solid #abc5e8; border-radius: 8px; color: #285a99; background: #e7f0ff; cursor: pointer; font-size: 12px; }
.device-push button:disabled { opacity: .6; cursor: wait; }
.device-push .device-push-error { color: #a24242; }
</style>
